export default function HotelViewHeaderController(
    $scope,
    $stateParams,
    userService,
    moment,
) {
    'ngInject';

            /**
             * Init params
             */
            const regionalSettings = userService && userService.getRegionalSettings();
            const checkInDate = moment($stateParams.checkInDate, regionalSettings.dateFormat);
            const checkOutDate = moment($stateParams.checkOutDate, regionalSettings.dateFormat);

            /**
             * Set Header label
             */
            $scope.headerData = angular.copy($stateParams);

            /**
             * Init CheckIn date
             */
            $scope.headerData.checkInDate = checkInDate.toISOString();

            /**
             * Init CheckOut date
             */
            $scope.headerData.checkOutDate = checkOutDate.toISOString();

            /**
             * Check that checkInDate isn`t bigger than checkOutDate
             * @type {*|!number}
             */
            $scope.headerData.diffDates = checkOutDate.diff(checkInDate, 'days');

            $scope.moment = moment;
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotelViewHeaderCtrl.js